module.exports = __webpack_public_path__ + "img/2002.843470a7.gif";